import { useState } from 'react';

export const useTransactions = () => {
  const [state, setState] = useState();

  const getTransactions = () => {
    const transactions = [
      {
        id: 5,
        name: 'Depósito',
      },
      {
        id: 2,
        name: 'Retiro',
      },
    ];
    setState(transactions);
  };
  return {
    state,
    setState,
    getTransactions,
  };
};
